import type { ShipmentStatus } from '../enums/ShipmentStatus'
import type { UserAddressType } from '@/features/user/domain/enums/UserAddressType'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'
import type { OrderFulfillmentMethod } from '@/features/order/domain/enums/OrderFulfillmentMethod'
import type { OrderPaymentStatus } from '@/features/order/domain/enums/OrderPaymentStatus'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { OrderTag } from '@/features/trackOrder/domain/enums/OrderTag'
import type { InvoiceEntity } from '@/features/order/domain/entities/InvoiceEntity'
import type { OrderDiscountEntity } from '@/features/order/domain/entities/OrderDiscountEntity'
import type { OrderPaymentType } from '@/features/order/domain/enums/OrderPaymentType'

export class ShipmentEntity {
  id?: string
  orderId?: string
  createdAt?: string
  orderPaymentStatus?: OrderPaymentStatus
  jobBranchLocation?: LngLatEntity
  orderEstimatedPreparationTime?: string
  orderFulfillmentMethod?: OrderFulfillmentMethod
  driverVehicleTemplate?: {
    type: VehicleTemplateType
    canHandleSensitiveOrders: false
  }
  driverId?: number
  jobId?: string
  missingPouchOperation?: boolean
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  driverCurrentLocation?: LngLatEntity

  branch?: {
    id: string
    locationName: string
    name: string
    phoneNumbers: string[]
    sid: number
    brandImageUrl?: string | null
  }
  status?: ShipmentStatus
  shipmentStatus?: ShipmentStatus
  source?: {
    longitude?: number
    latitude?: number
  }
  sourceName?: string | null
  destination?: {
    longitude?: number
    latitude?: number
  }
  destinationName?: string | null
  addressType?: UserAddressType
  position?: number
  statusSetOn?: string
  driverEarning?: number
  channel?: string
  driver?: DriverEntity
  estimatedDeliveryDuration?: number
  tags?: OrderTag[]
  invoice?: InvoiceEntity
  discount?: OrderDiscountEntity
  jetOrderInvoiceImagePath?: string | null
  orderReferenceCode?: string
  preparedAt?: string | null
  serviceId?: number
  serviceName?: string | null
  addressDescription?: string | null
  homeNumber?: string | null
  scheduledOrderTime?: string | null
  jetOrder?: {
    branchDeliveryFeeShareAmount?: number
    invoiceImagePath?: string | null
    vehicleTemplateType?: VehicleTemplateType
  }
  paymentType?: OrderPaymentType
  zohoBooksCreditAppliedAt?: string | null
  unavailableItemPreference?: {
    title?: string | null
  }
}
